import Vue from 'vue';
import _orderBy from 'lodash.orderby';
import Errors from '../classes/errors';
import { setCaptchaEuScript } from '../utils';
import { getFormRenderToken } from '../services/anti-bot';
import { isCaptchaEnabled } from '../services/captcha';

Vue.component('online-service-ordering-form-component', {
    props: {
        siteId: {
            type: Number,
        },
        allStores: {
            value: Array,
        },
        imStores: {
            value: Array,
        },
        captchaEuPublicKey: {
            value: String,
        },
    },

    data() {
        return {
            formRenderToken: '',
            errors: new Errors(),
            formCompleted: false,
            submitting: false,
            isSwitchButtonVisible: true,
            isNumberValid: true,
            requestType: 'private',
            requestIndex: 0,
            countryHandle: '',
            selectedBrandStore: null,
            model: '',
            stores: this.allStores || [],
            newsletterSignUp: false,

            dropdownCountry: null,
            dropdownStore: null,
        };
    },

    watch: {
        model(newValue) {
            if (newValue.toLowerCase().includes('im')) {
                this.stores = this.imStores || [];
            } else {
                this.stores = this.allStores || [];
            }
        },
    },

    computed: {
        isCompanyInputVisible() {
            return this.requestType === 'business';
        },
        isSubmitLoading: function () {
            return this.submitting ? 'button--loading' : '';
        },
        orderedStores: function () {
            return _orderBy(this.stores, 'title');
        },
    },

    mounted() {
        setCaptchaEuScript();

        getFormRenderToken().then((token) => {
            this.formRenderToken = token;
        });
        EventBus.$on('brandstore-selected', (brandstoreValue) => {
            this.selectedBrandStore = brandstoreValue;
        });
        this.$nextTick(() => {
            const modelInput = this.$el.querySelector('input[name="model"]');
            if (modelInput && modelInput.value) {
                this.model = modelInput.value;
            }
        });
    },

    methods: {
        handleToggleButtonActiveClass(index) {
            return this.requestIndex === index ? 'checked' : '';
        },

        scrollToFirstError() {
            Vue.nextTick(() => {
                document.querySelector('.new-input__container--error');
            });
        },

        handleMarketingConsentChange(e) {
            e.preventDefault();
            const isConsentChecked = e.target.checked;
            this.newsletterSignUp = isConsentChecked;
            const hiddenMarketingInput = document.querySelector('#marketing');
            if (!hiddenMarketingInput) return;
            hiddenMarketingInput.setAttribute(
                'value',
                isConsentChecked ? '1' : '0',
            );
        },

        async onSubmit(event) {
            event.preventDefault();
            const form = event.currentTarget;

            if (this.submitting) return;

            this.submitting = true;

            if (!this.isNumberValid) {
                this.submitting = false;
                return;
            }

            try {
                if (!(await isCaptchaEnabled())) {
                    await this.handleDataSubmit(form);
                    return;
                }

                const captchaSolution = await KROT.getSolution(
                    this.captchaEuPublicKey,
                );

                await this.handleDataSubmit(form, captchaSolution);
            } catch (e) {
                throw new Error(e);
            } finally {
                this.submitting = false;
            }
        },

        async handleDataSubmit(form, captchaSolution) {
            try {
                const formData = new FormData(form);
                if (captchaSolution) {
                    formData.append(
                        'captchaSolution',
                        JSON.stringify(captchaSolution),
                    );
                }
                formData.append(
                    'store',
                    this.selectedBrandStore
                        ? JSON.stringify(this.selectedBrandStore)
                        : '',
                );
                formData.append('formRenderToken', this.formRenderToken);
                const { data } = await axios.post('/', formData);
                const result = data;

                if (result.data.errors) {
                    this.submitting = false;
                    this.errors.clear();
                    this.errors.record(result.data.errors);
                    this.scrollToFirstError();
                    return;
                }

                this.errors.clear();
                this.isNumberValid = true;

                window.location = this.$refs.redirectUrl.value;
            } catch (e) {
                throw new Error(e);
            }
        },
    },
});
